import { createSelector } from '@reduxjs/toolkit'
import { ServiceGroup } from '@/models/service'
import { servicesSlice } from '@/store/servicesSlice'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { cartSlice } from '..'

export const servicesWithCartQuantitySelector = createSelector(
  [servicesSlice.selectors.data, cartSlice.selectors.cartReservations],
  (services, cartReservations) => {
    const result: ServiceGroup[] = []
    services?.serviceGroups.forEach((group) => {
      const aggregatedServices = group.services
        .map((service) => {
          const total = cartReservations.reduce((carry, reservation) => {
            const quantity = getBoughtServicesTotal(
              reservation.boughtServices[service.serviceId]
            )
            return carry + quantity
          }, 0)
          return {
            ...service,
            quantity: total,
          }
        })
        .filter((service) => (service?.quantity ?? 0) > 0)
      // check if anything is reserved
      const totalBoughtOnGroup = aggregatedServices.reduce(
        (carry, service) => carry + (service.quantity ?? 0),
        0
      )
      if (totalBoughtOnGroup < 1) {
        return
      }
      result.push({
        ...group,
        services: aggregatedServices,
      })
    })
    return result
  }
)

export const ticketsInCartTotalQuantity = createSelector(
  [servicesWithCartQuantitySelector],
  (servicesWithCartQuantity) => {
    const totalQuantity = servicesWithCartQuantity?.reduce(
      (groupAcc, group) =>
        groupAcc +
        group.services.reduce((acc, curr) => acc + (curr.quantity ?? 0), 0),
      0
    )
    return totalQuantity ?? 0
  }
)
